module.exports = __webpack_public_path__ + "static/form-one-column-do-8ab00e878c52f23b135832cbba93c47a.png";